import { useState } from "react";
import { Theme } from "../component/navigation/ThemeDropdown";

export default function SettingsIcon({ theme }: { theme: Theme }) {
    const [isSelected, setIsSelected] = useState(false);

    const handleClick = () => {
        setIsSelected((prev) => !prev);
    };

    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={handleClick}
        >
            <path
                d="M12 23.9969C18.6274 23.9969 24 18.625 24 11.9985C24 5.3719 18.6274 0 12 0C5.37259 0 0 5.3719 0 11.9985C0 18.625 5.37259 23.9969 12 23.9969Z"
                fill={
                    theme === "light"
                        ? isSelected
                            ? "#C6D92D"
                            : "#D8D8D8"
                        : isSelected
                          ? "#C6D92D"
                          : "#7A8690"
                }
                style={{
                    transition: "fill 0.3s ease",
                }}
            />
            <path
                d="M19.5237 11.1986C19.5237 10.9757 19.429 10.8536 19.2092 10.8048C18.7939 10.7162 18.3847 10.5819 17.9664 10.5239C17.8626 10.5086 17.771 10.4872 17.6916 10.4537C17.5542 9.9438 17.3466 9.46142 17.087 9.01567C17.3435 8.55466 17.6275 8.11502 17.8992 7.66623C17.9481 7.58379 17.9847 7.4922 18.0397 7.37619C17.9756 7.27849 17.9237 7.17468 17.8473 7.09225C17.4992 6.72589 17.1359 6.37479 16.7939 6.00537C16.6199 5.81608 16.458 5.80387 16.2504 5.94125C15.8138 6.23129 15.3741 6.51828 14.9252 6.78695C14.8977 6.80527 14.8611 6.81748 14.8244 6.82358C14.4367 6.61292 14.0244 6.44501 13.5939 6.32288C13.5695 6.2893 13.5512 6.25266 13.542 6.21908C13.4107 5.70312 13.2947 5.18104 13.1878 4.65897C13.1359 4.40557 13.0168 4.2804 12.7481 4.2865C12.2534 4.29871 11.7588 4.29566 11.2641 4.2865C11.0138 4.2804 10.8794 4.38725 10.8305 4.6315C10.7328 5.10472 10.6168 5.57794 10.5252 6.05116C10.5069 6.15191 10.4794 6.24351 10.4397 6.31678C9.99085 6.44195 9.56032 6.61598 9.16032 6.83885C9.12673 6.82358 9.09314 6.80527 9.0565 6.78084C8.62902 6.49385 8.18932 6.22824 7.76184 5.94125C7.55116 5.79776 7.39238 5.81913 7.21833 6.00537C6.88245 6.36868 6.53436 6.72283 6.18016 7.06783C5.98474 7.25712 5.95421 7.43725 6.10688 7.66928C6.29925 7.95626 6.44581 8.27683 6.6565 8.54856C6.77864 8.70731 6.87024 8.86302 6.91909 9.02178C6.65955 9.46447 6.45497 9.94685 6.31757 10.4537C6.31146 10.4537 6.30535 10.4537 6.29925 10.4567C5.80764 10.5636 5.31909 10.6948 4.82444 10.7956C4.56795 10.8475 4.4794 10.9879 4.4794 11.2291C4.48245 11.7543 4.48245 12.2794 4.4794 12.8014C4.4794 13.0213 4.56795 13.1495 4.7939 13.1983C5.20001 13.2838 5.60001 13.409 6.00917 13.4731C6.12215 13.4914 6.22596 13.5159 6.31757 13.5556C6.45803 14.0685 6.66566 14.5539 6.93131 14.9996C6.9252 15.0088 6.92215 15.018 6.91604 15.0271C6.63207 15.4698 6.36948 15.9217 6.09161 16.3674C5.96642 16.5628 5.97253 16.7307 6.14047 16.8986C6.50993 17.2711 6.8794 17.6436 7.23971 18.0222C7.40765 18.1992 7.56642 18.1931 7.76184 18.0618C8.19543 17.7688 8.63818 17.4818 9.08703 17.2162C9.11757 17.1978 9.15116 17.1887 9.19085 17.1795C9.58474 17.3932 10.0031 17.5642 10.4458 17.6833C10.4641 17.7199 10.4763 17.7626 10.4886 17.8115C10.5924 18.3244 10.7206 18.8343 10.8244 19.3472C10.8763 19.6006 10.9924 19.7227 11.2672 19.7135C11.7618 19.6983 12.2565 19.6983 12.7512 19.7135C13.0076 19.7197 13.1328 19.6158 13.1817 19.3716C13.2794 18.8862 13.3985 18.4068 13.4931 17.9214C13.5115 17.8268 13.5359 17.7474 13.5786 17.6802C14.0275 17.5581 14.4519 17.381 14.8519 17.1612C14.8794 17.1734 14.9069 17.1887 14.9344 17.207C15.3679 17.5001 15.8168 17.7718 16.2565 18.0618C16.4519 18.1901 16.6076 18.1962 16.7786 18.0161C17.1389 17.6344 17.5084 17.262 17.8779 16.8895C18.0367 16.7307 18.0519 16.5689 17.9359 16.3827C17.7221 16.0377 17.5359 15.6744 17.2947 15.3507C17.2031 15.2286 17.1328 15.0809 17.0839 14.9262C17.3435 14.4784 17.5469 13.993 17.6916 13.4801C17.6957 13.4801 17.6998 13.4771 17.7039 13.4731C18.2056 13.3703 18.6941 13.239 19.1839 13.1383C19.4474 13.0834 19.5359 12.947 19.5298 12.7117C19.5267 12.4754 19.5267 12.239 19.5267 12.0027C19.5267 11.7768 19.5328 11.5628 19.5237 11.1986Z"
                fill={
                    theme === "light"
                        ? isSelected
                            ? "#FFFFFF"
                            : "#606161"
                        : isSelected
                          ? "#2D3748"
                          : "#2D3748"
                }
                style={{
                    transition: "fill 0.3s ease",
                }}
            />
            <path
                d="M12 14.2333C13.2344 14.2333 14.2351 13.2328 14.2351 11.9985C14.2351 10.7642 13.2344 9.76367 12 9.76367C10.7656 9.76367 9.76489 10.7642 9.76489 11.9985C9.76489 13.2328 10.7656 14.2333 12 14.2333Z"
                fill={
                    theme === "light"
                        ? isSelected
                            ? "#C6D92D"
                            : "#D8D8D8"
                        : isSelected
                          ? "#C6D92D"
                          : "#7A8690"
                }
                style={{
                    transition: "fill 0.3s ease",
                }}
            />
        </svg>
    );
}
